<template>
    <entity-reader entity="plot" :id="id" :use-sharing="true">
        <template v-slot:[`reader`]="{ doc }">
            <v-row>
                <v-col cols="12">
                    <div class="text-h5">{{ doc.name }}</div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div v-html="doc.details" class="wrap-html"></div>
                </v-col>
            </v-row>
        </template>
        <template v-slot:[`extraTabs`]="">
            <v-tab>
                Monsters
            </v-tab>
            <v-tab>
                Encounters
            </v-tab>
        </template>
        <template v-slot:[`extraTabItems`]="{ userPermissions }">
            <v-tab-item>
                <monster-manager :id="id" :permissions="userPermissions"></monster-manager>
            </v-tab-item>
            <v-tab-item>
                <encounter-list :id="id" />
            </v-tab-item>
        </template>
    </entity-reader>
</template>
<script>
import EntityReader from '../../components/EntityRead'
import MonsterManager from './components/MonsterManager.vue'
import EncounterList from './components/EncounterList.vue'
export default {
    name: 'PlotReader',
    components: {
        'entity-reader': EntityReader,
        'monster-manager': MonsterManager,
        'encounter-list': EncounterList,
    },
    props: {
        id: {
            type: [Number, String],
            required: true,
            validator: value => {
                return !!value
            },
        },
    },
}
</script>
<style scoped>
.wrap-html {
    overflow-wrap: break-word;
}
</style>
